import { Icon1, Icon2 } from "../../Common/Data/SvgIcons";
import IncomeCard from "./IncomeCard";
import IncomeChartClass from "./IncomechartCard";
import ProfileGreeting from "./ProfileGreetingCard";
import GrowthOverview from "./GrownCard";
import Login from "./creadential_keendroid";
import RecentToppers from "./Recent_toppers";
import UserCard from "./UserCard";
import TransactionCard from "./TransactionCard";
import { Container, Row, Col } from "reactstrap";
import image from "../../../assets/images/dummy_pic.jpeg";
import { HiOutlineUserCircle, HiOutlineUser } from "react-icons/hi";
import StudentAtt from "./StudentAtt";
import Progress from "./ProgressReport";
import { BaseURL, GpsBaseURL, uniqueToken, Role } from "../../../api/DataApis";
import request from "../../../Apis/request";
import axios from "axios";
import { LuUser } from 'react-icons/lu';

// import {  } from "react-icons/fa";
import React from "react";
import { useEffect, useState } from "react";
// import { HiOutlineUserCircle } from 'react-icons/hi';

import { BsEvStation } from "react-icons/bs";
import { FaChargingStation } from "react-icons/fa6";
import { GrTransaction } from "react-icons/gr";
import Loader from "../../../Modules/Settings/Loader";
import { Link } from "react-router-dom";
// import { faRupeeSign } from '@fortawesome/free-solid-svg-icons';

const Dashboard = () => {
  const [loading, setLoading] = useState(false);
  const [dashboardWidgetData, setDashboardWidgetData] = useState({});
  const [TotalAdmissions, setTotalAdmissions] = useState([]);
   const [filteredData, setFilteredData] = useState([]);
   const [totalCount, setTotalCount] = useState(null);
 const [loadings, setLoadings] = useState(false);
  const [Limit, setLimit] = useState({});
  const [page, setPage] = useState(1);
document.title = "Dashboard";
  const fetchData = async () => {
    setLoading(true);

    var url = `${GpsBaseURL}/dashboard/getall`;

    let res = await request({
      url: url,
      method: "GET",
    
      headers: {
        "Content-type": "application/json; charset=UTF-8",
        Authorization: `Bearer ${uniqueToken}`,
      },
    });

    console.log("res", res);

    if (res && res.data) {
      setDashboardWidgetData(res?.data);
    }
    if (res && res?.data?.data) {
      setTotalAdmissions(res.dashboardWidget.newAdmissions);
    }

    setLoading(false); // Set loading to false after data is fetched
  };

  useEffect(() => {
    if (uniqueToken) {
      fetchData();
    }
  }, [uniqueToken]);

  
  const fetchCorporates = async (page) => {
    setLoadings(true);
    
    // Base API URL
    let apiEndpoint = decodeURIComponent(`${GpsBaseURL}/dashboard/corporates`);
   
    
    // Prepare query parameters
    
    
    // Add search term to the query params if it's not empty
    // if (searchTerm) queryParams.push(`searchText=${searchTerm}`);
 
    
    
    // const apiUrl = `${apiEndpoint}?${queryParams.join('&')}`;
  
    try {
      const response = await axios.get(apiEndpoint, {
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: `Bearer ${uniqueToken}`, // Replace with actual token if needed
        },
      });
  
      console.log("response", response);
     
      setFilteredData(response.data?.data);
      setTotalCount(response.data.count || 0);
      setLimit(response?.data?.limit);
    // Assuming API returns totalCount for pagination
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoadings(false);
    }
  };
  
  // Re-fetch users whenever searchTerm changes
    useEffect(() => {
      if (Role === "false") {
        fetchCorporates();  // Only fetch corporate data if Role === "false"
      }
    }, [Role]);

  const TotalAdmission = TotalAdmissions.new_admissions;

  console.log("dashboardData", dashboardWidgetData);
  console.log("TotalAdmissions", TotalAdmissions);
  console.log("TotalAdmission", TotalAdmission);
  return (
    <>
    { loading ? (
      <div className="loader-container">
        <Loader />
      </div>
    ) : (
    <Container fluid={true} className="dashboard-default-sec" style={{paddingLeft:"16px"}}>
     
      <Row>
        {/* <Col xl="5" className="box-col-12 des-xl-100"> */}
        <Row >
          <div className="col-md-3 mt-3 ">
            {/* <Image attrImage={{ className: 'img-fluid rounded-circle', src: image, alt: '', title: '' }} /> */}
            {/* <IncomeCard image  className="img-fluid rounder-circle" src= {image}  amount='8,50,49' title='Total Students'/> */}
            {/* <IncomeCard iconClass={<Icon1 />} amount='8,50,49' title='Total Students' percent="95.54%" /> */}
            {/* <IncomeCard iconClass={<Icon1 />} amount='8,50,49' title='Total Students' /> */}
            <IncomeCard
              iconClass={<HiOutlineUserCircle />}
              amount={dashboardWidgetData?.totalUserCount}
              title="Register Users"
              path="/usermanagement/users"
            />
          </div>
          <div className="col-md-3 mt-3 ">
            <IncomeCard
               iconClass={<span style={{ fontSize: "20px", fontWeight: "bold",  }}><HiOutlineUserCircle /></span>} 
              amount ={dashboardWidgetData?.todayUserCount}
              percentage="98%"
              title="Today Added Users"
              path="/usermanagement/users"
            />
          </div>

          <div className="col-md-3 mt-3 ">
            <IncomeCard
              iconClass={<HiOutlineUserCircle />}
              amount ={dashboardWidgetData?.productCount}
              percentage="98%"
              title="Total Products"
              path="/product-lists"
            />
          </div>
          <div className="col-md-3 mt-3">
            <IncomeCard
                iconClass={<span style={{ fontSize: "20px", fontWeight: "bold", color: "#28a745" }}>₹</span>} 
              amount={dashboardWidgetData?.totalPrice}
              title="Total Product Price"
              path=""
            />
          </div>

          <div className="col-md-3 mt-3">
            <IncomeCard
              iconClass={<span style={{ fontSize: "20px", fontWeight: "bold", color: "#28a745" }}>₹</span>}
              amount={dashboardWidgetData?.todayTotalPrice}
              title="Today Product Price Added"
              path=""
            />
          </div>
          {Role === "false" && (
            <>
          <div className="col-md-3 mt-3">
            <IncomeCard
               iconClass={<HiOutlineUserCircle/>} 
              amount={dashboardWidgetData?.corporateCount}
              title="Total Corporates"
              path="/corporate/list"
            />
          </div>
         
          <div className="col-md-3 mt-3">
            <IncomeCard
               iconClass={<HiOutlineUserCircle/>} 
              amount={dashboardWidgetData?.todayCorporateCount}
              title="Today Added Corporates"
              path="/corporate/list"
            />
          </div>
          </>
           )}
             <div className="col-md-3 mt-3">
            <IncomeCard
               iconClass={<HiOutlineUserCircle/>} 
              amount={dashboardWidgetData?.orderCount}
              title="Total Orders"
              path="/corporate/list"
            />
          </div>
          <div className="col-md-3 mt-3">
            <IncomeCard
               iconClass={<HiOutlineUserCircle/>} 
              amount={dashboardWidgetData?.orderTotalPrice}
              title="Total Order Price"
              path="/corporate/list"
            />
          </div>
          <div className="col-md-3 mt-3">
            <IncomeCard
               iconClass={<HiOutlineUserCircle/>} 
              amount={dashboardWidgetData?.todayOrderCount}
              title="Today's Orders"
              path="/corporate/list"
            />
          </div>
          <div className="col-md-3 mt-3">
            <IncomeCard
               iconClass={<HiOutlineUserCircle/>} 
              amount={dashboardWidgetData?.todayOrderTotalPrice}
              title="Today Order Price"
              path="/corporate/list"
            />
          </div>
          <div className="col-md-3 mt-3">
            <IncomeCard
               iconClass={<HiOutlineUserCircle/>} 
              amount={dashboardWidgetData?.productCombCount}
              title="Combo Product Count"
              path="/corporate/list"
            />
          </div>
          <div className="col-md-3 mt-3">
            <IncomeCard
               iconClass={<HiOutlineUserCircle/>} 
              amount={dashboardWidgetData?.totalComboPrice}
              title="Total Combo Collection"
              path="/corporate/list"
            />
          </div>
          <div className="col-md-3 mt-3">
            <IncomeCard
               iconClass={<HiOutlineUserCircle/>} 
              amount={dashboardWidgetData?.todayProductComboCount}
              title=" Today Combo Product Count"
              path="/corporate/list"
            />
          </div>
          <div className="col-md-3 mt-3">
            <IncomeCard
               iconClass={<HiOutlineUserCircle/>} 
              amount={dashboardWidgetData?.todayTotalComboPrice}
              title="Today Combo Product Collection"
              path="/corporate/list"
            />
          </div>
       </Row>

    
      <>

      {Role ===  "false" && (
      <div className="portlet-body mx-3">
            <div className="d-flex justify-content-between align-items-center mb-3">
  <div className="d-flex align-items-center">
    <h4 className="mb-0 me-3">Corporates({totalCount ? totalCount : "Loading..." })</h4> {/* Add margin to the right of the heading */}
   
  </div>

</div>
<hr style={{ marginTop: "0px" }} />
<div className="row">
  <form className="form-horizontal" role="form" style={{ marginTop: "5px" }}>
    <div
      className="row px-3"
      style={{
        display: "flex",
        alignItems: "center",
        //gap: "10px", // Consistent spacing between filters
        flexWrap: "wrap", // Allow wrapping on smaller screens
      }}
    >
</div>
  </form>
</div>


<div className="card-body" style={{ marginLeft: "-19px" }}>
  {loadings ? (
    <Loader /> 
  ) : totalCount === 0 ? (
    <div className="text-center">
      <h5>No User Data Found</h5> {/* Message to indicate no data found */}
    </div>
  ) : (
    <>
    <div className="table-responsive">
      <table
        className="display dataTable"
        id="advance-1"
        style={{ tableLayout: 'auto', width: '100%', borderCollapse: 'collapse' }}
      >
       <thead>
  <tr>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Sr No</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Logo</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Admin Image</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Name</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Corporate Name</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Phone Code</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Phone No</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Email</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>PAN Number</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Total Users</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Total Products</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Total Income</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Created Date</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Action</th>
 
  </tr>
</thead>
 <tbody>
          {filteredData?.map((corporate, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>
  {corporate?.logo ? (
    <img src={corporate.logo} alt="User Logo" style={{ width: '100px', height: 'auto' }} />
  ) : (
 <LuUser/>
  )}
</td>
<td>
  {corporate?.admin_image ? (
    <img src={corporate.admin_image} alt="Admin image" style={{ width: '100px', height: 'auto' }} />
  ) : (
  <LuUser/>
  )}
</td>
       <td>{corporate?.name}</td>
       <td>{corporate?.corporate_name}</td>
       <td>+{corporate?.phone_code}</td>
       <td>{corporate?.phone}</td>
       <td>{corporate?.email}</td>
       <td>{corporate?.pan_number}</td>
       <td>   <Link to={`/usermanagement/users/${corporate?._id}`} state={{ UserViewData: corporate, CoporateID : corporate?._id  }}>{corporate?.totalUsers}</Link></td>
       <td>{corporate?.totalProducts}</td>
       <td>{corporate?.totalPrice}</td>
       
       <td>{corporate?.created_date}</td>
             
   
            
            
<td style={{ whiteSpace: 'nowrap' }}>
                &nbsp;&nbsp;&nbsp;&nbsp;
       
&nbsp;&nbsp;&nbsp;
                <Link to={`/usermanagement/users/${corporate?._id}`} state={{ UserViewData: corporate }}>
                <LuUser/>
</Link>
            
           </td>               
            </tr>
          ))}   
        </tbody>
      </table>
</div>
   
    </>
  )}
</div>

 </div>
 )}
      </>
       
      </Row> 
    </Container>)}
  
  </>
  )
};

export default Dashboard;
